import { useRef } from 'react';

export function useAddAnotherRef() {
  const addAnother = useRef(false);

  const setAddAnother = () => {
    addAnother.current = true;
  };

  const setNoMore = () => {
    addAnother.current = false;
  };

  return [addAnother, setAddAnother, setNoMore];
}

export default useAddAnotherRef;
